import styled from "styled-components";

export const SwitcherContainer = styled.div`
    margin: 24px auto;
    max-width: 50%;
`;
